import {
    Alert, Avatar, Box, Button, CircularProgress, Dialog, DialogActions,
    DialogContent, DialogTitle, Divider, List, ListItem,
    ListItemAvatar, ListItemText, Stack, Typography
} from '@mui/material';

const currency = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
});

const ProductDialog = ({ open, setOpen, cart, loading }) => {
    const handleClose = () => setOpen(false);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Detalle de carrito abandonado</DialogTitle>
            <DialogContent dividers>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
                        <CircularProgress />
                    </Box>
                ) : cart ? (
                    <>
                        <Stack spacing={0.5} sx={{ mb: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                {cart.fullname}
                            </Typography>
                            <Typography variant="body2">{cart.email}</Typography>
                            <Typography variant="body2">Se creó: {cart.created}</Typography>
                            <Typography variant="body2">Última actividad: {cart.updated}</Typography>
                            <Typography variant="body2">Recordatorio: {cart.reminder_date}</Typography>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 1 }}>
                                Total estimado: {currency.format(cart.estimated_total)}
                            </Typography>
                        </Stack>

                        <Divider />

                        <List>
                            {cart.products.map(product => (
                                <ListItem key={product.prod_var_id} alignItems="flex-start">
                                    <ListItemAvatar>
                                        <Avatar alt={product.img.alt} src={product.img.id} />
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={product.title}
                                        secondary={
                                            <Stack component="span" spacing={0.25}>
                                                <Typography component="span" variant="body2">
                                                    {currency.format(product.price)} × {product.quantity}
                                                </Typography>
                                                <Typography component="span" variant="body2" sx={{ fontWeight: 700 }}>
                                                    Subtotal: {currency.format(product.subtotal)}
                                                </Typography>
                                            </Stack>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </>
                ) : (
                    <Alert severity="warning">No se pudo cargar el detalle del carrito.</Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProductDialog;
